// src/icons/WeightIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function WeightIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 24,
    viewBox: "0 0 25 24",
    width: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        d: "M5.92489 19.5H19.0749L17.4999 8.5H7.49989L5.92489 19.5ZM12.4999 7C12.9249 7 13.2811 6.85625 13.5686 6.56875C13.8561 6.28125 13.9999 5.925 13.9999 5.5C13.9999 5.075 13.8561 4.71875 13.5686 4.43125C13.2811 4.14375 12.9249 4 12.4999 4C12.0749 4 11.7186 4.14375 11.4311 4.43125C11.1436 4.71875 10.9999 5.075 10.9999 5.5C10.9999 5.925 11.1436 6.28125 11.4311 6.56875C11.7186 6.85625 12.0749 7 12.4999 7ZM15.0999 7H17.4999C17.8851 7 18.2188 7.12083 18.5011 7.3625C18.7836 7.60417 18.9499 7.91667 18.9999 8.3L20.5499 19.3C20.6166 19.75 20.5031 20.1458 20.2094 20.4875C19.9156 20.8292 19.5374 21 19.0749 21H5.92489C5.46239 21 5.08431 20.8292 4.79064 20.4875C4.49681 20.1458 4.38322 19.75 4.44989 19.3L5.99989 8.3C6.04989 7.91667 6.21614 7.60417 6.49864 7.3625C6.78097 7.12083 7.11472 7 7.49989 7H9.89989C9.76656 6.76667 9.66656 6.52858 9.59989 6.28575C9.53322 6.04308 9.49989 5.78117 9.49989 5.5C9.49989 4.66667 9.79156 3.95833 10.3749 3.375C10.9582 2.79167 11.6666 2.5 12.4999 2.5C13.3332 2.5 14.0416 2.79167 14.6249 3.375C15.2082 3.95833 15.4999 4.66667 15.4999 5.5C15.4999 5.78333 15.4666 6.04583 15.3999 6.2875C15.3332 6.52917 15.2332 6.76667 15.0999 7Z",
        fill: "currentColor"
      })
    ]
  });
}
export {
  WeightIcon
};
//# sourceMappingURL=WeightIcon.mjs.map